import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "../mock";
import Reveal from "./Reveal";

const FaqSection = () => {
  const [open, setOpen] = useState(0);
  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <Reveal className="text-center mb-10">
          <span className="text-orange-brand font-bold text-sm uppercase tracking-wide">General FAQs</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-navy font-head mt-2">Frequently Asked Questions</h2>
        </Reveal>
        <div className="space-y-3">
          {FAQS.map((f, i) => (
            <Reveal key={i} delay={i * 30}>
              <div className={`rounded-2xl border transition-colors ${open === i ? "border-orange-brand/40 bg-orange-brand/[0.03]" : "border-gray-200 bg-[#f7f9fc]"}`}>
                <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left">
                  <span className="font-semibold text-navy font-head">{f.q}</span>
                  <span className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center transition-colors ${open === i ? "bg-orange-brand text-white" : "bg-white text-navy border border-gray-200"}`}>
                    {open === i ? <Minus size={18} /> : <Plus size={18} />}
                  </span>
                </button>
                <div className="grid transition-all duration-300" style={{ gridTemplateRows: open === i ? "1fr" : "0fr" }}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm text-navy/65 leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
